import { uuidv7 } from "uuidv7";
/** Generate a UUID v7 string for synced entities (client-side). */
export function newId() {
    return uuidv7();
}
/** Namespace for legacy import idempotent ids (uuidv5). */
export const NAMESPACE_HAULSHEET_LEGACY = "6b2f6c1e-2d0a-4c55-9f3e-6b8a3c1d7e10";
//# sourceMappingURL=ids.js.map